import { useAuth } from "../../../../context";
import { useMutation, useQuery } from "react-query";
import { CapitalGoods } from "../../../../api";

export const capitalGoodsKeys = {
  items: () => ["capitalGoodsItems"]
};

export function useUpdateCapitalGoods(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, data }) =>
    callApi(CapitalGoods.updateCapitalGoods, { questionnaireId, data }), config);
}

export function useGetCapitalGoodsItems(params, config) {
  const { callApi } = useAuth();
  return useQuery(
    [...capitalGoodsKeys.items(), params.queryParams.page, params.queryParams.size, params.queryParams.sort],
    () => callApi(CapitalGoods.getCapitalGoodsItems, params), config);
}

export function useAddCapitalGoodsItems(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, data }) =>
    callApi(CapitalGoods.addCapitalGoodsItems, { questionnaireId, data }), config);
}

export function useUpdateCapitalGoodsItem(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, recordId, data }) =>
    callApi(CapitalGoods.updateCapitalGoodsItem, { questionnaireId, recordId, data }), config);
}

export function useDeleteCapitalGoodsItem(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, recordId }) =>
    callApi(CapitalGoods.deleteCapitalGoodsItem, { questionnaireId, recordId }), config);
}

export function useImportCapitalGoodsItems(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, data }) =>
    callApi(CapitalGoods.importCapitalGoodsItems, { questionnaireId, data }), config);
}

export function useDownloadCapitalGoodsTemplate(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId }) => callApi(CapitalGoods.getCapitalGoodsTemplate, questionnaireId), config);
}